<template>
  <v-flex>
    <v-toolbar flat class="mx-auto mb-4">
      <v-btn icon v-on:click.native="goBack()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title class="headline">{{msg}}</v-toolbar-title>
    </v-toolbar>
    <v-flex mx-auto>
      <voice-date-select></voice-date-select>
      <v-switch :label="'Sick'" v-model="switch1" color="green" @change="updateSickValue"></v-switch>
      <vocal-activity-home v-if="false"></vocal-activity-home>
      <v-layout row wrap mt-4>
        <v-flex xs10>
          <v-progress-linear v-model="percentageVAL" height="20" color="success" animate></v-progress-linear>
        </v-flex>
        <v-flex xs2>
          <div class="text-xs-left pl-4">
            <div class="vocal-activity-value headline ">{{ percentageVAL }}%</div>
            <div class="vocal-activity-label">{{ vocalActivityValue }} of {{ totalDailyAllotment }} daily allotment</div>
          </div>
        </v-flex>
      </v-layout>
      <voice-data-table></voice-data-table>
      <div class="text-xs-center mt-4">
        <v-btn round color="primary" to="/val">Add Activity</v-btn>
      </div>
    </v-flex>
  </v-flex>
</template>

<script>
  import DateSelect from '../DateSelect.vue'
  import ValDataTable from './ValDataTable.vue'
  import CreateActivityMutation from '../mutations/CreateActivityMutation'
  import DeleteActivityMutation from '../mutations/DeleteActivityMutation'
  import { ListActivitiesForCurrentUser } from '@/components/queries'
  import VocalActivityHome from '../home/VocalActivityHome.vue'
  import AppConst from '../AppConst.js'

  export default {
    data () {
      return {
        msg: 'Voice Activity Log',
        switch1: (localStorage.sickMarkerValue == 'true'),
        vocalActivityValue: 0, // localStorage.vocalActivityTotal,
        totalDailyAllotment: 0 // localStorage.totalDailyAllotment,
        // percentageVAL: this.calActVal(),
      }
    },
    components: {
      'voice-date-select': DateSelect,
      'voice-data-table': ValDataTable,
      'vocal-activity-home': VocalActivityHome
    },
    methods: {
      async getTotaledActivityValue () {
        this.$localStorage.currentDateSick = ''
        this.$localStorage.sickMarkerValue = false

        const { data } = await this.$apollo.query({
          variables: {
            actDate: localStorage.currentDate,
            username: localStorage.subID
          },
          query: ListActivitiesForCurrentUser
        })
        const items = data.listActivitiesForCurrentUser.items || []

        const sick = items.filter(it => it.activityType === 'Sick').pop()
        if (sick) {
          this.$localStorage.currentDateSick = sick.id
          this.$localStorage.sickMarkerValue = 'true'
          this.switch1 = 'true'
        }

        const ignore = ['VoiceFeeling', 'Sick', 'WaterConsumption', 'NapTaken', 'VoiceCeilingPitch']
        const activities = items.filter(it => !ignore.includes(it.activityType))
        let tempTotalAct = activities.reduce((t, a) => t + a.value, 0)

        const napTotal = items.filter(it => it.activityType === 'NapTaken').length
        const feel = items.filter(it => it.activityType === 'VoiceFeeling').pop() || null
        let napValue = 1
        if (feel) {
          napValue = AppConst.voiceFeelDefaults.find(it => it.text === feel.intensity).napValue
        }
        tempTotalAct = Math.max(tempTotalAct - napTotal * napValue, 0)

        this.vocalActivityValue = tempTotalAct
        this.$localStorage.vocalActivityTotal = tempTotalAct
        this.switch1 = (this.$localStorage.sickMarkerValue === 'true')
        return tempTotalAct
      },
      async getTotalDailyAllotment () {
        var tempTotalAct = 0
        const { data } = await this.$apollo.query({
          variables: {
            actDate: localStorage.currentDate
          },
          query: ListActivitiesForCurrentUser
        })
        const items = data.listActivitiesForCurrentUser.items || []
        // return (feeling && feeling.value) ? feeling.value : 0
        const feel = items.find(it => it.activityType === 'VoiceFeeling')
        if (feel && feel.value) {
          tempTotalAct = feel.value
          this.$localStorage.currentDateVoiceFeelID = feel.id
          this.totalDailyAllotment = tempTotalAct
          this.$localStorage.totalDailyAllotment = tempTotalAct
        }
        return tempTotalAct
      },
      goBack () {
        this.$router.back()
      },
      async updateSickValue (selectedItem) {
        if (selectedItem === true) {
          // gather inputs
          var avaInput = {
            id: localStorage.subID + '--' + (new Date().getTime()),
            username: localStorage.subID,
            actDate: localStorage.currentDate,
            activityType: 'Sick',
            timestamp: (new Date().getTime()),
            value: '0',
            intensity: 'Sick'
            // notes: this.inputNotes,
          }

          // add to dynamodb
          const data = await this.$apollo.mutate({
            variables: {
              input: avaInput
            },
            mutation: CreateActivityMutation
          })
          localStorage.currentDateSick = data.data.createActivity.id
          localStorage.sickMarkerValue = selectedItem
        } else {
          // we need to delete the sick value for this day
          // use localStorage.currentDateSick, value to remove the sick for the current day
          await this.$apollo.mutate({
            variables: {
              input: {
                id: localStorage.currentDateSick
              }
            },
            mutation: DeleteActivityMutation
          })
          selectedItem = 'false'
          localStorage.sickMarkerValue = selectedItem
          localStorage.currentDateSick = ''
        }
      },
      calActVal () {
        var temp = Math.floor((localStorage.vocalActivityTotal / localStorage.totalDailyAllotment) * 100)
        if (isNaN(temp) || !isFinite(temp)) { temp = 0 }
        return temp
      }
    },
    computed: {
      percentageVAL () {
        if (this.totalDailyAllotment === 0) {
          return 0
        } else {
          const temp = Math.floor((this.vocalActivityValue / this.totalDailyAllotment) * 100)
          return (!isNaN(temp) && isFinite(temp)) ? temp : 0
        }
      }
    },
    async mounted () {
      const data = await this.getTotalDailyAllotment()
      this.totalDailyAllotment = data

      const total = await this.getTotaledActivityValue()
      this.vocalActivityValue = total
      localStorage.totalDailyAllotment = this.totalDailyAllotment
      localStorage.vocalActivityTotal = this.vocalActivityValue

      this.$root.$on('voiceFeelChange', async data => {
        this.totalDailyAllotment = data
        localStorage.totalDailyAllotment = data
      })

      this.$root.$on('DateChange', async () => {
        const data = await this.getTotalDailyAllotment()
        this.totalDailyAllotment = data

        const total = await this.getTotaledActivityValue()
        this.vocalActivityValue = total;

        localStorage.totalDailyAllotment = this.totalDailyAllotment
        localStorage.vocalActivityTotal = this.vocalActivityValue
      })
    }

  }
</script>


// WEBPACK FOOTER //
// src/components/val/ValDetails.vue